const getSignInPathDefault = () => {
  return 'start-page';
};

export default getSignInPathDefault;
